import { rangePresets, defaultRangePreset } from '@gogame/intl-ts';
import { object, array, string, number, ref } from '@gogame/schemas';

import {
  FILTER_PERIOD,
  GA_FILTER_PERIOD,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_CLUSTERS,
  FILTER_PLATFORMS,
  FILTER_TYPE,
  FILTER_SUB_TYPE,
  FILTER_MINE_ONLY,
} from '../constants';

export const EMPTY_FILTERS = {
  [FILTER_PERIOD]: rangePresets.LIFETIME.value,
  [FILTER_MINE_ONLY]: undefined,
};

export const subTypesParamsSchema = object({
  [FILTER_TYPE]: number().required(),
});

export const filtersSchema = object({
  [FILTER_PERIOD]: array(string()).constants(defaultRangePreset),
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_CLUSTERS]: array(number()),
  [FILTER_PLATFORMS]: array(number()),
  [FILTER_TYPE]: number(),
  [FILTER_SUB_TYPE]: array(number()),
  [FILTER_MINE_ONLY]: number(),
}).default({
  [FILTER_PERIOD]: rangePresets.LAST_90_DAYS.value,
  [FILTER_MINE_ONLY]: undefined,
});

export const filtersGaSchema = filtersSchema.shape({
  [GA_FILTER_PERIOD]: ref(FILTER_PERIOD, (value) => {
    return array(string())
      .constants(defaultRangePreset)
      .cast(value, { applyConst: true });
  }),
});
